import gql from 'graphql-tag';
import {priceDetailsFragments as reactPriceDetailsFragments} from '@homeaway/react-price-details';

// https://github.expedia.biz/vrbo-booking-experience/react-price-details/blob/master/src/components/PriceDetails/PriceDetails.fragments.js
const priceDetailsFragments = {
    CheckoutExperienceModel: gql`
        fragment PriceDetailsCheckoutExperienceModel on CheckoutExperienceModel {
            priceDetails {
                edapQuoteSuccess
                edapPriceQuotePresented
                instantBooking
                merchantOfRecordConfig
                displayedPriceDetails {
                    priceDisplayNightlies {
                        perNightCost {
                            currency
                            amount
                            localized
                        }
                        type
                    }
                    priceDisplayLineItem {
                        amount
                        type
                        title
                        link
                        linkText
                        mixedCurrencyDisclaimer
                    }
                }
                totalSavings {
                    totalSavings
                    totalSavingsAmountOKApplied
                }
                notes {
                    amount
                    title
                }
                totalNumeric {
                    totalInCents
                }
                merchandisingSpaceItems {
                    message
                    type
                }
                dueNow {
                    title
                    amount
                    tooltips {
                        title
                        amount
                        tooltip
                    }
                    nonrefundable
                }
                dueNowPlans {
                    type
                    dueNow {
                        title
                        amount
                        tooltips {
                            title
                            amount
                            tooltip
                        }
                        nonrefundable
                    }
                }
                payments {
                    status
                }
                lineItems {
                    title
                    link
                    linkText
                    mixedCurrencyDisclaimer
                }
                loyalty {
                    accountDetails {
                        earnEligible
                        redeemEligible
                        balanceInCurrency
                        tier {
                            key
                            name
                        }
                    }
                    redemptionValue {
                        points
                        pointsValueInMonetaryAmount
                        exchangeRateId
                    }
                    labels {
                        acceptBurnLabel
                        acceptBurnLabelPoSu
                        acceptBurnLabelPoSuTooltip
                        oneKeyMultiCurrency
                        acceptBurnSublabel
                        declineBurnLabel
                        declineBurnSublabel
                        radioGroupLabel
                        earnRewardsLabel
                        earnRewardsLabelBurningPoints
                        earnRewardsLabelBurningPointsMultiCurrency
                        earnPriceDetailsLabel
                        earnPriceDetailsLabelBurningPoints
                        earnPriceDetailsMultiCurrencyLabel
                        usedBurnLabel
                        awardBreakdownLabels {
                            awardBreakdownSummaryLabel
                            breakdownLabels
                        }
                        awardBreakdownLabelsBurningPoints {
                            awardBreakdownSummaryLabel
                            breakdownLabels
                        }
                    }
                    loyaltyEligibleAmounts {
                        siteFees
                        sitePrice
                        siteTaxes
                    }
                    totalsWithBurn {
                        amount
                        decimalAmount
                        title
                        tooltip
                        subItems {
                            title
                        }
                    }
                    dueNowWithBurn {
                        title
                        amount
                        tooltips {
                            title
                            amount
                            tooltip
                        }
                        nonrefundable
                    }
                    totalNumericWithBurn {
                        totalInCents
                    }
                    paymentsWithBurn {
                        title
                        amount
                        paidText
                        infoText
                        status
                    }
                }
                averageNightlies {
                    perNightCost {
                        currency
                        amount
                        localized
                    }
                    type
                }
                ...PriceDetailsPriceDetails
            }
        }
        ${reactPriceDetailsFragments.PriceDetails}
    `,
};

export default priceDetailsFragments;
